<template>
  <div class="arc_top" v-bind:class="{ page__arc: true }">
     <b-row v-if="arc_list_show">
       <b-col sm="8">
          <b-form-select v-model="arc_list_sel" :options="arc_list"
             :select-size="5"
             size="sm">
          </b-form-select>
       </b-col>
       <b-col sm="4">
         <b-row>
          <b-col>
            <span
              class="material-vue"
              style="color:white;font-size:1.5rem;cursor:pointer;padding:0 0.25rem;line-height:2rem;"
              size="sm" @click="refresh">
              refresh
            </span>
            <b-button v-if="arc_list_sel && arc_list_sel.handle && arc_list_sel.suburl && has_subtitles"
              variant="primary" target="_blank"
              style="padding:0 0.25rem;font-size:0.7rem;line-height:1.3rem;text-decoration:underline;float:right;"
              size="sm" :href="arc_list_sel.suburl" download>
              VTT
            </b-button>
            <b-button v-if="arc_list_sel && arc_list_sel.handle && arc_list_sel.dlurl"
              variant="primary" target="_blank"
              style="padding:0 0.25rem;line-height:1.3rem;font-family:'Material Icons';float:right;"
              size="sm" :href="arc_list_sel.dlurl" download>
              file_download
            </b-button>
            <b-button v-if="is_mod && arc_list_sel && arc_list_sel.handle"
              variant="primary" style="padding:0 0.25rem;line-height:1.3rem;float:right;"
              size="sm" @click="openEditArc">
              Edit
            </b-button>
          </b-col>
         </b-row>
         <b-row v-if="is_mod && arc_list_sel && can_clip">
          <b-col>
             <b-button-group style="width:100%">
               <b-button class="mbtn-vthin" style="width:50%"
                 :variant="(pbmode == 'seek')? 'vxon':'outline-secondary'"
                 @click="set_arcplayer_pbmode('seek')">
                 Seek
               </b-button>
               <b-button class="mbtn-vthin" style="width:50%;"
                 title="Click to select part(s) of this recording" 
                 :variant="(pbmode == 'seek')? 'outline-secondary':'vxon'"
                 @click="set_arcplayer_pbmode('clip_select')">
                 Select
               </b-button>
             </b-button-group>
           </b-col>
         </b-row>
         <b-row v-if="is_mod && arc_list_sel && can_clip && pbmode == 'seek'">
          <b-col>
             <b-button class="mbtn-thin" size="sm"
               v-if="has_clip"
               variant="danger"
               @click="create_from_clips()">
               Create
             </b-button>
          </b-col>
         </b-row>
         <b-row v-if="arc_list_sel && can_clip && pbmode != 'seek'">
          <b-col>
             <b-button class="mbtn-thin" size="sm"
               style="color:white"
               variant="outline-secondary"
              >
                {{clip_cnt}} / 3 Ranges
             </b-button>
             <b-button class="mbtn-thin" size="sm"
               v-if="has_clip"
               variant="primary"
               @click="clr_arcplayer_clips()">
               Reset
             </b-button>
          </b-col>
         </b-row>
       </b-col>
     </b-row>

    <b-row class="" v-if="arc_list_sel" style="position:relative">
     <b-col sm="12">
       <arc-player
         :src="arc_list_sel"
         v-on:player="set_arcplayer"
         v-on:status="arcplayer_status"
         >
       </arc-player>
     </b-col>
    </b-row>
    
    <b-modal id="bv-edit" size="lg"
       v-if="arc_list_sel"
       title="Edit the recording" hide-footer>
       <b-row style="padding: 0.5rem 0;">
         <b-col sm="12">
           <b-input type="text"
             v-model.trim="arc_edit.title"
             placeholder="Recording Title">
           </b-input>
         </b-col>
       </b-row>
       <b-row style="padding: 0.5rem 0;">
         <b-col md="12">
           <b-button-group class="thingroup" style="width:100%">
             <b-button class="mt-1 mb-0 thinbtn" style="width:33%"
               :disabled="cast.handle == arc_list_sel.handle || cast_edit.handle == arc_list_sel.handle"
               :variant="arc_edit.priv_var"
               @click="setPublic('private')">
                 Private
             </b-button>
             <b-button class="mt-1 mb-0 thinbtn" style="width:33%;"
               :variant="arc_edit.pub_var"
               @click="setPublic('account')">
                 All {{ acc }}
             </b-button>
             <b-button class="mt-1 mb-0 thinbtn" style="width:33%;"
               :variant="arc_edit.pub_nauth_var"
               @click="setPublic('anyone')">
                 Public to Anyone
             </b-button>
           </b-button-group>
         </b-col>
       </b-row>

       <b-row style="padding: 0.5rem 0;"
         v-if="cast.handle && cast.handle == arc_list_sel.handle">
         <b-col md="12">
             <span>
               This is currently showing on your broadcast page. Removing it will leave your broadcast page empty.
             </span>
             <span v-if="cast.handle != cast_edit.handle">
               Once you save, this will no longer appear on your broadcast page.
             </span>
         </b-col>
         <b-col md="12">
           <b-button size="sm"
             v-if="cast.handle == cast_edit.handle"
             variant="outline-secondary"
             @click="changeBroadcast('rem')">
               Remove this from your Broadcast page.
           </b-button>
           <b-button size="sm"
             v-if="cast.handle != cast_edit.handle"
             variant="vxon"
             @click="changeBroadcast()">
               Remove this from your Broadcast page.
           </b-button>
         </b-col>
       </b-row>
       <b-row style="padding: 0.5rem 0;"
         v-if="cast.handle && cast.handle == arc_list_sel.handle">
         <b-col md="12">
           <b-button size="sm"
             v-if="!cast_edit.can_ask"
             variant="outline-secondary"
             @click="changeBroadcastAsk(true)">
               Viewers cannot ask questions
           </b-button>
           <b-button size="sm"
             v-if="cast_edit.can_ask"
             variant="vxon"
             @click="changeBroadcastAsk(false)">
               Viewers can ask questions
           </b-button>
         </b-col>
       </b-row>
       <b-row style="padding: 0.5rem 0;"
         v-if="arc_edit.pub && cast.handle && cast.handle != arc_list_sel.handle">
         <b-col md="12">
            <span>
              This is not your active broadcast. Current one is {{ cast.title }}.
              Switching to it will replace what is shown on your broadcast page.
            </span>
            <span v-if="cast.handle != cast_edit.handle">
              Once you save, this will become your new broadcast.
            </span>
         </b-col>
         <b-col md="12">
           <b-button size="sm"
             v-if="cast.handle == cast_edit.handle"
             variant="outline-secondary"
             @click="changeBroadcast('set')">
               Switch to this for your broadcast page.
           </b-button>
           <b-button size="sm"
             v-if="cast.handle != cast_edit.handle"
             variant="vxon"
             @click="changeBroadcast()">
               Switch to this for your broadcast page.
           </b-button>
         </b-col>
       </b-row>
       <b-row style="padding: 0.5rem 0;"
         v-if="arc_edit.pub && !cast.handle">
         <b-col md="12"
            v-if="!cast.handle">
             <span>
               There is nothing currently active on your broadcast page.
             </span>
             <span v-if="cast_edit.handle">
               Once you save, this will be your new broadcast.
             </span>
         </b-col>
         <b-col md="12" v-if="arc_edit.pub">
           <b-button size="sm"
             v-if="!cast_edit.handle"
             variant="outline-secondary"
             @click="changeBroadcast('set')">
               Start showing this on your broadcast page.
           </b-button>
           <b-button size="sm"
             v-if="cast_edit.handle"
             variant="vxon"
             @click="changeBroadcast()">
               Start showing this on your broadcast page.
           </b-button>
         </b-col>
       </b-row>

       <b-row style="padding: 0.5rem 0;" v-if="arc_edit.pub">
         <b-col sm="12">
           <div> <div> <span> Sharable URL </span> </div>
                 <span id="shareurl"
                    style="font-size:0.7rem;overflow-wrap:anywhere;">{{ getShareURL(arc_list_sel.handle) }}</span><span class="material-vue" style="color:black;font-size:0.9rem;line-height:0;cursor:pointer;" @click="doCopy2Clip('shareurl')"> content_copy </span>
           </div>
         </b-col>
       </b-row>
       <div style="padding: 1vw 0px">
         <b-button-group class="">
           <b-button class="sm" @click="updateArc()"
              v-if="!isSelDelMark()"
             :disabled="!isSelChanged()"
             :variant="isSelChanged()?'primary':'outline-secondary'">
             Save
           </b-button>
           <b-button class="sm" @click="selDelMark()"
             :disabled="cast.handle == arc_list_sel.handle"
             v-if="!isSelDelMark()"
             variant="outline-danger">
             Delete
           </b-button>
           <b-button class="sm" @click="deleteArc()"
             v-if="isSelDelMark()"
             variant="danger">
             Confirm Delete
           </b-button>
         </b-button-group>
         <b-button-group class="float-right">
           <b-button class="sm" @click="selCancel()"
             variant="secondary">
             Cancel
           </b-button>
         </b-button-group>
       </div>
     </b-modal>

     <b-modal id="bv-clipload" size="sm"
       title="Preparing recording"
       @close="clipload_close"
       @hide="clipload_hide"
       hide-footer
       >
       {{clipload_per}}
     </b-modal>

     <b-modal id="bv-createclip" size="sm"
       title="Creating new clip"
       @close="createclip_close"
       @hide="createclip_hide"
       hide-footer>
       <div> Segment {{ create_clip.seg }} </div>
       <div> Video {{ create_clip.v }} </div>
       <div> Audio {{ create_clip.a }} </div>
       <div> Meta  {{ create_clip.m }} </div>
       <div v-if="create_clip.err"> Error  {{ create_clip.err }} </div>
     </b-modal>

  </div>
</template>

<script>
import vx_api from "../vuemix";
import { sync } from "vuex-pathify";
import store from "../store";
import ArcPlayer from "../components/ArcPlayer";

export default {
  name: "arc",
  components: {
    ArcPlayer,
  },
  created() {
    let vue = this;
    window.vx_set_room(window.vx, vue.$router.currentRoute.params.acc, vue.$router.currentRoute.params.uid,"archive");
    vue.getArcList();
  },
  mounted() {
     let vue = this;
     vue.hov_el = window.document.getElementById('seekhov');
     if (vue.$parent.mydevice.set_background) {
        $("body").addClass("setbackground");
     }
     vue.acc = window.vx.acc;
  },
  beforeDestroy() {
    let vue = this;
  },
  data() {
    return {
      is_mod: false,
      cast: {},
      cast_edit: {
        handle: null,
        can_ask: false,
      },
      arc_list: [],
      arc_list_show: true,
      arc_list_sel: {},
      arc_edit: {
        title: "",
        pub: false,
        pub_nauth: false,
        priv_var: "outline-secondary",
        pub_var: "outline-secondary",
        pub_nauth_var: "outline-secondary",
        del_mark: false,
      },
      acc: null,
      arcplayer: null,
      can_clip: false,
      has_clip: false,
      clip_cnt: 0,
      pbmode: "seek",
      has_subtitles: false,
      clipload_per: 0,
      create_clip: {seg:"",v:"",a:"",m:"",err:""},
    };
  },
  watch: {
    $route(to, from) {
      window.vx_set_room(window.vx, to.params.acc, to.params.uid, "archive");
      this.getArcList();
    },
  },
  methods: {
    toCF: function(arc) {
      if (!arc) { return; }
      if (arc.url) {
        arc.url = arc.url.replace("https://s3.amazonaws.com/vuemix-mmarc",
                                  "https://d1xyplvc108m9i.cloudfront.net");
      }
      if (arc.dlurl) {
        arc.dlurl = arc.dlurl.replace("https://s3.amazonaws.com/vuemix-mmarc",
                                      "https://d1xyplvc108m9i.cloudfront.net");
        if (arc.dlurl.match(/.mp4$/)) {
          arc.suburl = arc.dlurl.replace(/.mp4$/,".vtt");
        } else if (arc.dlurl.match(/.mp3$/)) {
          arc.suburl = arc.dlurl.replace(/.mp3$/,".vtt");
        }
      }
      return arc;
    },
    refresh: function() {
      this.getArcList();
    },
    sec2human: function(s) {
      if (!s) { return "0 sec"; }
      if (s < 90) {
         return Math.trunc(s)+"sec";
      } else if (s < 3600) {
         return Math.trunc(s/60)+"min";
      } else if (s < 48*3600) {
         return Math.trunc(s/3600)+"hr";
      }
      return Math.trunc(s/(24*3600))+"days";
    },
    getArcList: function() {
      let vue = this;
      if (!window.vx.room) { return; }
      let opt = {};
      let only_for_handle;
      if (vue.$router.currentRoute.params.handle) {
         only_for_handle = ""+vue.$router.currentRoute.params.handle;
         opt.handle = only_for_handle;
         vue.arc_list_show = false;
      } else {
         opt.playable = true;
         vue.arc_list_show = true;
      }
      console.log("only for handle:"+JSON.stringify(only_for_handle));
      api_arclist(window.vx, opt, function(res) {
           let sel_handle = ""+only_for_handle;
           if (vue.arc_list_sel) {
             sel_handle = ""+vue.arc_list_sel.handle;
           }
           if (!res) { return; }
           if (res.cast) {
              vue.cast.handle = res.cast.handle;
              vue.cast.can_ask = res.cast.can_ask;
           }
           vue.is_mod = res.is_mod || false;
           if (res.a) {
             vue.arc_list = [];
             vue.arc_list_sel = {};
             res.a.forEach(function(ar) {
                let opt = {};
                ar = vue.toCF(ar);
                opt.value = ar;
                opt.text = ar.title || "no title set";
                opt.text += "  [ "
                if (ar.d_dur) {
                  /* If clipped and a display dur exists, use for text */
                  opt.text += vue.sec2human(ar.d_dur/1000)+" long";
                } else if (ar.dur) {
                  opt.text += vue.sec2human(ar.dur/1000)+" long";
                }
                if (ar.last_ms) {
                  let delta = (Date.now() - ar.last_ms)/1000;
                  if (!opt.done && delta < 15) {
                    opt.text += "   LIVE";
                  } else {
                     opt.text += "  @"+vue.sec2human(delta)+" ago";
                  }
                }
                opt.text += " ]"
                if (vue.cast.handle == ar.handle) {
                  opt.text = opt.text+" <== Broadcast";
                  opt.html = "<div class=\"bcast\"> "+opt.text+"</div>";
                }
                vue.arc_list.unshift(opt);
                if (only_for_handle && ar.handle == only_for_handle) {
                   vue.arc_list_sel = ar;
                } else if (!only_for_handle && ar.handle == sel_handle) {
                   vue.arc_list_sel = ar;
                }
             });
             if (only_for_handle && !vue.arc_list_sel.url) {
               vue.$parent.notification = {
                   alertCountDown: 8,
                   alertVariant: "warning",
                   alertMessage: "The recording does not exist or you need to sign in to view it."
               };
             }
           }
        });
    },
    selCancel: function() {
       let vue = this;
       //console.log("selCancel:"+JSON.stringify(vue.arc_list_sel));
       if (vue.arc_edit.del_mark) {
          vue.arc_edit.del_mark = false;
       } else {
          vue.$bvModal.hide('bv-edit');
       }
    },
    isSelChanged: function() {
       let vue = this;
       let changed = false;
       ["title","pub","pub_nauth"].forEach(function(f) {
          if (vue.arc_list_sel[f] != vue.arc_edit[f]) {
            changed = true;
          }
       });
       ["handle","can_ask"].forEach(function(f) {
          if (vue.cast[f] != vue.cast_edit[f]) {
            changed = true;
          }
       });
       return changed;
    },
    selDelMark: function() {
       let vue = this;
       //console.log("selDelMark");
       vue.arc_edit.del_mark = true;
    },
    isSelDelMark: function() {
       let vue = this;
       //console.log("isSelDelMark");
       if (vue.arc_edit.del_mark) { return true; }
       return false;
    },
    updateArc: function() {
       let vue = this;
       let ar = {};
       //console.log("updateArc");
       ar.handle = vue.arc_list_sel.handle;
       ["title","pub","pub_nauth"].forEach(function(f) {
          if (vue.arc_list_sel[f] != vue.arc_edit[f]) {
            ar[f] = vue.arc_edit[f];
            vue.arc_list_sel[f] = vue.arc_edit[f];
          }
       });
       if (vue.cast.handle != vue.cast_edit.handle) {
          if (!vue.cast_edit.handle) {
            /* Intent is to remove this arc from current broadcast */
            ar.cast_rem = true;
          } else {
            /* Intent is to make this the new broadcast */
            ar.cast_add = true;
          }
          vue.cast.handle = vue.cast_edit.handle;
          ar.can_ask = vue.cast_edit.can_ask;
       } else if (vue.cast.handle && vue.cast.can_ask !== vue.cast_edit.can_ask) {
          ar.can_ask = vue.cast_edit.can_ask;
       }
       //console.log(JSON.stringify(ar));
       api_arcupdate(window.vx, ar, function(data) {
          vue.refresh();
          vue.$bvModal.hide('bv-edit');
       });
    },
    deleteArc: function() {
       let vue = this;
       let ar = {};
       ar.handle = vue.arc_list_sel.handle;
       api_arcdel(window.vx, ar, function(data) {
         vue.$bvModal.hide('bv-edit');
         vue.arc_list_sel = {};
         vue.refresh();
       });
    },
    setPublicVariants: function() {
      let vue = this;
      if (!vue.arc_edit.pub) {
        vue.arc_edit.priv_var = "vxon";
        vue.arc_edit.pub_var = "outline-secondary";
        vue.arc_edit.pub_nauth_var = "outline-secondary";
      } else if (vue.arc_edit.pub && !vue.arc_edit.pub_nauth) {
        vue.arc_edit.priv_var = "outline-secondary";
        vue.arc_edit.pub_var = "vxon";
        vue.arc_edit.pub_nauth_var = "outline-secondary";
      } else if (vue.arc_edit.pub_nauth) {
        vue.arc_edit.priv_var = "outline-secondary";
        vue.arc_edit.pub_var = "outline-secondary";
        vue.arc_edit.pub_nauth_var = "vxon";
      }
    },
    setPublic: function(scope) {
      let vue = this;
      if (!vue.arc_list_sel.handle) { return; }
      if (scope == "private") {
        vue.$set(vue.arc_edit, "pub", false);
        vue.$set(vue.arc_edit, "pub_nauth", false);
      } else if (scope == "account") {
        vue.$set(vue.arc_edit, "pub", true);
        vue.$set(vue.arc_edit, "pub_nauth", false);
      } else if (scope == "anyone") {
        vue.$set(vue.arc_edit, "pub", true);
        vue.$set(vue.arc_edit, "pub_nauth", true);
      }
      vue.setPublicVariants();
    },
    openEditArc: function() {
      let vue = this;
      vue.arc_edit.title = vue.arc_list_sel.title;
      vue.arc_edit.pub = vue.arc_list_sel.pub;
      vue.arc_edit.pub_nauth = vue.arc_list_sel.pub_nauth;
      vue.arc_edit.del_mark = false;
      vue.setPublicVariants();
      vue.cast_edit.handle = vue.cast.handle;
      vue.cast_edit.can_ask = vue.cast.can_ask || false;
      this.$bvModal.show('bv-edit');
    },
    changeBroadcastAsk: function(val) {
       let vue = this;
       vue.cast_edit.can_ask = val?true:false;
    },
    changeBroadcast: function(action) {
      let vue = this;
      if (!action) {
         /* Restore */
         vue.cast_edit.handle = vue.cast.handle;
      } else if (action == "set") {
         vue.cast_edit.handle = vue.arc_list_sel.handle;
      } else if (action == "rem") {
         vue.cast_edit.handle = null;
      }
    },
    getShareURL: function(handle) {
      let url = "https://" + window.location.host + window.location.pathname  + "?rt=no";
      url += this.$router.resolve({name: 'arc', params:{handle: handle}}).href;
      return url;
    },
    doCopy2Clip: function(elid) {
      let el = document.getElementById(elid);
      if (!window.copyEText2Clip(el)) {
        console.log("copy failed");
      }
    },
    set_arcplayer: function(player) {
      let vue = this;
      //console.log("set_arcplayer",player);
      vue.arcplayer = player;
      vue.pbmode = "seek";
      vue.can_clip = false;
      vue.has_clip = false;
      vue.clip_cnt = 0;
      vue.has_subtitles = false;
    },
    arcplayer_status: function(s) {
      let vue = this;
      //console.log(JSON.stringify(s));
      vue.can_clip = s.can_clip || false;
      vue.has_clip = s.has_clip || false;
      vue.clip_cnt = s.clip_cnt || 0;
      vue.pbmode = s.pbmode || "seek";
      vue.has_subtitles = s.has_subtitles;
    },
    clipload_close: function(ev) {
      let vue = this;
      vue.arcplayer.pbmode("seek");
      vue.clipload_canhide = true;
      vue.$bvModal.hide('bv-clipload');
    },
    clipload_hide: function(ev) {
      let vue = this;
      if (!vue.clipload_canhide) {
         ev.preventDefault();
      }
    },
    set_arcplayer_pbmode: function(mode) {
      let vue = this;
      if (!vue.arcplayer) { return; }
      vue.pbmode = mode;
      if (mode == "clip_select") {
        vue.has_clip = false;
        vue.clipload_canhide = false;
        vue.clipload_per = "";
        vue.$bvModal.show('bv-clipload');
        vue.arcplayer.pbmode(mode, function(err,frac) {
           if (err) {
             vue.clipload_per = "An error occurred. Close and retry.";
           } else if (frac >= 1) {
             setTimeout(function() {
               vue.clipload_canhide = true;
               vue.$bvModal.hide('bv-clipload');
             }, 1);
             vue.clipload_per = 0+"%";
           } else {
             vue.clipload_per = Math.round(100*frac)+"%";
           }
        });
      } else {
        vue.arcplayer.pbmode(mode);
        let spec = vue.arcplayer.get_clip_spec();
        //if (spec && spec.blocks && spec.blocks.length) {
        //  vue.has_clip = true;
        //}
      }
    },
    clr_arcplayer_clips: function() {
      let vue = this;
      vue.arcplayer.clear_clips();
    },
    create_step: function(url, cmd, step) {
      let vue = this;
      //console.log(step,JSON.stringify(cmd));
      issue_http({
        url: url,
        type: "PUT",
        data: JSON.stringify(cmd),        
        nocred: true,
        done:function(status, data) {
          //console.log("done",status,data);
          let j = to_json(data);
          if (!j || !j.ok || !j.state) {
             vue.createclip_canhide = true;
             if (j.ok) {
               vue.create_clip = {seg: "Finished"};
             } else {
               vue.create_clip.err = "Error "+j.msg;
             }
             return;
          }
          try {
            let blk = cmd.spec.blocks[j.state.block_i];
            //let vcnt = blk.vend - blk.vstart;
            //let acnt = blk.aend - blk.astart;
            vue.create_clip.seg =
               `${j.state.block_i+1} / ${cmd.spec.blocks.length}`;
            if (j.state.v <= blk.vend) {
              vue.$set(vue.create_clip, "v", `${j.state.v} / ${blk.vend}`);
              vue.create_clip.a = "";
              vue.create_clip.m = "";
            } else if (j.state.a <= blk.aend) {
              vue.create_clip.v = "Done";
              vue.$set(vue.create_clip, "a", `${j.state.a}/${blk.aend}`);
              vue.create_clip.m = "";
            } else {
              vue.create_clip.v = "Done";
              vue.create_clip.a = "Done";
              vue.$set(vue.create_clip, "m", `${j.state.new_m}`);
            }
            //console.log(JSON.stringify(vue.create_clip));
          } catch(e) {
            console.warn(e);
          }
          cmd.state = j.state;
          vue.create_step(url, cmd, step+1);
        }
      });
    },
    create_from_clips: function() {
      let vue = this;
      if (!vue.arcplayer) { return; }
      let spec = vue.arcplayer.get_clip_spec();
      if (!spec) {
        return;
      }
      //console.log(JSON.stringify(spec));

      let tm = Date.now()/100;
      let id = "";
      while (tm > 0) {
        id = window.vx_fake62(tm) + id;
        tm = Math.trunc(tm / 62);
      }
      for (let i=0; i<10; i++) {
        id = id + window.vx_fake62(62*Math.random());
      }
      let cmd = {};
      cmd.src_handle = vue.arc_list_sel.handle;
      cmd.spec = spec;
      cmd.dst_handle = id;
      cmd.title = (vue.arc_list_sel.title||"")+"Copy";
      //console.log(JSON.stringify(cmd));

      let url = vx.rq_endpoint+"/room/"+vx.room.main_room+"/arc/copy";
      url += "?acc=" + vx.room.acc;
      if (vx.user && vx.user.creds) {
        url += "&uid=" + vx.user.id;
        if (is_my_room(vx)) {
          url += "&" + vx.user.creds["myroom"];
        } else {
          url += "&" + vx.user.creds["me"];
        }
      }
      vue.create_clip.seg = "Starting...";
      vue.$bvModal.show('bv-createclip');
      vue.create_step(url, cmd, 1);
    },
    createclip_close: function(ev) {
      let vue = this;
      vue.createclip_canhide = true;
      vue.$bvModal.hide('bv-createclip');
    },
    createclip_hide: function(ev) {
      let vue = this;
      if (!vue.createclip_canhide) {
         ev.preventDefault();
      }
    },
  },
};
</script>
<style lang="scss" scoped>

.arc_top {
  margin: 0 1rem;
}

.header {
  position: relative;
  flex: 0 0 auto;
  display: flex;
  flex-flow: row;
  align-items: start;
  background-color: rgba(255, 255, 255, 0.2);
  color: #ebffff;
  padding: 3px 3px;
  font-family: "Roboto Condensed", sans-serif;
  font-size: 16px;
  line-height: 16px;
}

.content,
.flex_fill {
  flex: 1 1 0;
}

.content {
  position: relative;
}

.arccontainer {
  position: relative;
  padding:0;
  min-width:300px;
  width:100%;
  height:100%;
}

.arcplay {
  display:flex;
  align-items: center;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
}

.arcctrl {
  position:absolute;
  top: 0px;
  left: 0px;
  width:100%;
  height:100%;
}

#arc_wall {
  width: 100%;
  max-height: calc(100vh - 100px);
  object-fit:contain;
}

.pbtop {
  position:absolute;
  bottom:10px;
  /*width:100%;*/
  display:flex;
  flex-direction:row;
  line-height:0;
  margin:0.2rem 1rem;
  opacity:0;
}

.arcctrl:hover .pbtop {
  background-color: rgba(0,0,0,0.7);
  opacity: 1;
  transition: opacity 250ms ease-out 0s;
}

.pbbut {
  font-size:1.2rem;
  flex: 0 0 auto;
  flex-basis:30px;
  border: none;
  background: none;
  color: white;
  outline: none;
}

.pbelp {
  flex: 0 0 auto;
  flex-basis:40px;
  line-height:1.2rem;
  font-size:0.7rem;
  color:white;
  text-align:center;
}

.pbcore {
  flex: 1 1 auto;
  line-height:1.2rem;
}

#seekhov {
  line-height:1.2rem;
  font-size:0.7rem;
  color:white;
  background-color:#202020;
  padding: 0 3px;
  border-radius:3px;
  opacity:0;
}

#arc_pb:hover + #seekhov {
  opacity:1;
  transition: 0.2s;
}

#arc_pb {
  background-color:transparent;
  width:99%;
  height:0.5rem;
}

#pblive {
  color: #aaaaaa;
  font-size: 0.7rem;
  border-radius:0.25rem;
  margin:0.2rem;
}

#pblive[enabled="enabled"] {
  background-color: red;
  font-weight: 700;
}

.mbtn-vthin {
  padding:0;
  margin: 0;
  height: 1.1rem;
  font-size: 0.7rem;
}

.mbtn-thin {
  padding:0 0.5rem;
  height: 1.1rem;
  font-size: 0.7rem;
}

</style>
